import CountryPageRenderer from '../components/CountryPageRenderer';
import bahamasData from '../data/country-pages/bahamas';

export default function BahamasCountryPage() {
  return <CountryPageRenderer data={bahamasData} />;
}
